"use client"
import localStorageCall from "@/services/Methods/localstorage.hook";
import { ContextData, storeAssigned, _getPrice, _pointsPrice, _getCvValue, _scrollToUp } from "@/services/Methods/normalMethods";
import { _getWebCatId, getAllProductApi, getAllProductApiPagination } from "@/services/Redux/Reducer/AllProductSlice";
import _, { ceil } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";

const withProductHOC = (Component, section) => {
    const WithProductHOComponent = (props) => {

        const data = useContext(ContextData);
        const dispatch = useDispatch();
        const { params, rankUpgrad, activeStep, setpActive } = props;
        const { addToCartProducts, pathname, setAddToCartProduct, setOpenMiniCart, searchParams } = data;
        const [selectedCategory, setSelectedCategory] = useState(+(_getWebCatId('All Products')))
        const CATEGORIES = [
            { name: "All Products", id: _getWebCatId('All Products') },
            // { name: "Enrollment", id: _getWebCatId('Enrollment') },
            { name: "Skincare", id: _getWebCatId('Skincare') },
            { name: "Body Care", id: _getWebCatId('Bodycare') },
            { name: "Hair Care", id: _getWebCatId('Haircare') },
            { name: "Nutrition", id: _getWebCatId('Nutrition') },
            { name: "Club ViÁgo", id: _getWebCatId('Club Viago') },

        ];
        const itemId = searchParams?.get('itemId');
        const memoRizedSelector = createSelector(
            state => state?.AllProductSlice,
            (productState) => ({
                loading: productState?.isLoading
            })
        )
        const { loading } = useSelector((state) => memoRizedSelector(state))

        const [allProductState, setAllProductState] = useState([]);
        const [onlyAllProductsData, setOnlyAllProductsData] = useState([]);
        const [AllOthersProducts, setAllOtherProducts] = useState([]);
        const [packProducts, setPackProducts] = useState([]);
        const [category, setCategory] = useState("All Products");
        const [offset, setOffSet] = useState(1);
        const [totalRecords, setTotalRecords] = useState(0);
        const [searchText, setSearchText] = useState("");
        const [sortOrder, setSortOrder] = useState('sort');
        console.log("props", props);
        useEffect(() => {
            if (itemId) {
                const seachItem = searchParams?.get('search');
                if (seachItem) {
                    setSearchText(seachItem);
                }
                setSelectedCategory(+itemId)
                _getPorductAccordingSection(+itemId, 0, seachItem);
            }
            else {
                _getPorductAccordingSection(_.includes(pathname, 'main-enrollment') ?
                    _getWebCatId(activeStep === 0 && setpActive === 0 ? 'Step1Enrollment' : activeStep === 0 && setpActive === 1 ? 'Step2Enrollment' : activeStep === 1 ? 'Step3Enrollment' : 'Enrollment')
                    : selectedCategory, 0);
            }
            setOffSet(1);
        }, [section, selectedCategory, itemId, _getWebCatId, setpActive]);
        // console.log("selectedCategory", selectedCategory);

        function _getPorductAccordingSection(categoryVal, currentPage = offset - 1, searchData = "", callback = null, sortingPara = "") {
            dispatch(getAllProductApiPagination(currentPage, categoryVal, (data, totalProducts) => {
                const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
                setTotalRecords(totalProducts);

                console.log("datadatadatadatadatadatadatadata********************", data)

                let ProductData = _.compact(_.map(data, (row) => {
                    const SECTION_USE = rankUpgrad ? rankUpgrad : (CUSTOMER_TYPE?.role && section === 'normal') ? CUSTOMER_TYPE?.role : section;
                    let CONDITION = _.includes(['ambassador'], SECTION_USE) ? _getPrice(row, 3) : _.includes(['member', 'main_enrollment'], SECTION_USE) ? _getPrice(row, row?.title === 'Ambassador Renewal Fee ' ? 3 : 2) : _.includes(['VIP'], SECTION_USE) ? _getPrice(row, 1) : _getPrice(row, 2);
                    if (CONDITION || (CONDITION === 0)) {
                        if (row?.itemPricing.find(data => data?.countryCode.toLowerCase() === storeAssigned())) {

                            return _ProductStructure(row);
                        }
                    }
                }));
                if (callback) {
                    callback(ProductData, categoryVal);
                } else {
                    if (categoryVal !== 1000 && ProductData?.length === 0 && searchData) {
                        _getPorductAccordingSection(_getWebCatId('All Products'), 0, searchData, (products, catID) => {
                            if (catID === 1000 && products?.length > 0 && searchData) {
                                setAllProductState(products);
                                // router.push(`/${storeAssigned()}/products?itemId=1000&search=${searchData}`)
                            } else {
                                setAllProductState(ProductData);
                            }
                        });
                    } else {
                        setAllProductState(ProductData);
                    }
                }
                if (category === "All Products") {
                    setOnlyAllProductsData(ProductData)
                }
                setAllOtherProducts(data);
            }, searchData, (sortingPara || sortOrder), rankUpgrad));

        }

        function _onPaginationChange(e) {
            const selectedPage = e.selected;
            const offsetpage = selectedPage + 1;
            setOffSet(offsetpage)
            _getPorductAccordingSection(selectedCategory, offsetpage - 1);
            _scrollToUp();
        }

        function _addToCartFunction(id, frequency = "oneTime", category_id = "") {
            const PRODUCTS = addToCartProducts[section + 'Products'];
            const FIND_PRODUCT = _.find(allProductState, { id });

            console.log("allProductStateallProductStateallProductState", allProductState);

            console.log("FIND_PRODUCTFIND_PRODUCT", FIND_PRODUCT);

            // const AmbassadorRenewalProduct = _.find(allProductState, { title: "Ambassador Renewal Fee " });
            // Find a single product with title "Ambassador Renewal Fee" and countryName "IN"
            // const AmbassadorRenewalProduct = _.find(allProductState, {
            //     title: "Ambassador Renewal Fee ",
            //     countryCode: storeAssigned().toUpperCase(),
            // });

            // if (!AmbassadorRenewalProduct) {
            //     const AmbassadorRenewalProduct = _.find(allProductState, { title: "Ambassador Renewal Fee " });
            // }
            let AmbassadorRenewalProduct = _.find(allProductState, {
                title: "Ambassador Renewal Fee ",
                country_Code: storeAssigned() ? storeAssigned().toUpperCase() : undefined,
            });

            if (!AmbassadorRenewalProduct) {
                // Reassign the same variable without 'const'
                AmbassadorRenewalProduct = _.find(allProductState, { title: "Ambassador Renewal Fee " });
            }

            console.log(AmbassadorRenewalProduct);
            // const AmbassadorRenewalProduct = _.filter(allProductState, { title: "Ambassador Renewal Fee " });

            console.log("AmbassadorRenewalProductAmbassadorRenewalProductAmbassadorRenewalProduct", AmbassadorRenewalProduct);

            const FIND_ALREADY_PRODUCT = _.find(PRODUCTS, { id });
            let ADD_PRODUCTS = [];
            if (FIND_ALREADY_PRODUCT) {
                ADD_PRODUCTS = [..._.reject(PRODUCTS, FIND_ALREADY_PRODUCT), {
                    ...FIND_ALREADY_PRODUCT,
                    quantity: !_.includes(['main_enrollment'], rankUpgrad) ? FIND_ALREADY_PRODUCT?.quantity + FIND_PRODUCT?.quantity : 1,
                    category_id: category_id,
                    frequency: _.includes(["Ambassador Registration Fee"], FIND_ALREADY_PRODUCT?.title) ? 'member' : frequency
                }];
            } else {
                if (_.includes(["Ambassador Registration Fee"], FIND_PRODUCT?.title)) {
                    ADD_PRODUCTS = [...PRODUCTS, { ...FIND_PRODUCT, member: true, frequency: 'member' }]
                }
                else {
                    ADD_PRODUCTS = [...PRODUCTS, { ...FIND_PRODUCT, frequency }]
                }
            }
            _frequancyChange(id, frequency)

            localStorageCall().setItem(String(section + 'Products'), JSON.stringify(ADD_PRODUCTS));
            localStorageCall().setItem('RenewalProduct', JSON.stringify([AmbassadorRenewalProduct]))
            setAddToCartProduct((prv) => ({ ...prv, [section + 'Products']: ADD_PRODUCTS }));
            setOpenMiniCart(true);
        }

        //checkout products
        function _checkoutQuantityIncDec(id, section) {

            const PRODUCTS = allProductState;
            const FINDINDEX_LOCAL = _.findIndex(PRODUCTS, { id: id });
            if (FINDINDEX_LOCAL > -1) {
                PRODUCTS[FINDINDEX_LOCAL]['quantity'] = (section === "sub") ? ((PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 > 0) ? PRODUCTS[FINDINDEX_LOCAL]?.quantity - 1 : 1) : PRODUCTS[FINDINDEX_LOCAL]?.quantity + 1;
                setAllProductState([])
                setAllProductState(PRODUCTS);
            }
        }

        function _frequancyChange(id, autoshipType) {
            const PRODUCTS = allProductState;
            const FINDINDEX_LOCAL = _.findIndex(PRODUCTS, { id: id });
            if (FINDINDEX_LOCAL > -1) {
                // PRODUCTS[FINDINDEX_LOCAL]['autoshipType'] = autoshipType;
                PRODUCTS[FINDINDEX_LOCAL]['frequency'] = autoshipType;
                setAllProductState([])
                setAllProductState(PRODUCTS);
            }
        }

        function _ProductStructure(row) {
            const CUSTOMER_TYPE = localStorageCall().getItem('customerTypeDescr');
            const PriceType = _.includes(['main_enrollment'], rankUpgrad) ? (row?.title === 'Ambassador Renewal Fee ' ? 3 : 2) : _.includes(['ambassador'], CUSTOMER_TYPE?.role) ? 3 : _.includes(['VIP'], CUSTOMER_TYPE?.role) ? 1 : 2
            let NORMAL_PRICEING = { oneTime: _getPrice(row, PriceType), autoship: _getPrice(row, PriceType) };
            return ({
                id: row?.itemId,
                itemId: row?.itemId,
                image: row?.mediumImage,
                title: row?.title,
                normal_oneTime: NORMAL_PRICEING?.oneTime || 0,
                normal_autoship: NORMAL_PRICEING?.autoship || 0,
                retail_oneTime: _getPrice(row, PriceType) || 0,
                retail_autoship: _getPrice(row, PriceType) || 0,
                customer_oneTime: _getPrice(row, PriceType) || 0,
                customer_autoship: _getPrice(row, PriceType) || 0,
                distributor_oneTime: _getPrice(row, PriceType) || 0,
                distributor_autoship: _getPrice(row, PriceType) || 0,
                cv_oneTime: _.includes(['ambassador'], CUSTOMER_TYPE?.role) || rankUpgrad === 'ambassador' ? _getCvValue(row, 3) : null,
                cv_autoship: _.includes(['ambassador'], CUSTOMER_TYPE?.role) || rankUpgrad === 'ambassador' ? _getCvValue(row, 3) : null,
                quantity: 1,
                itemCode: row?.fullItemCode,
                isEligibleForAutoOrder: row?.isEligibleForAutoOrder,
                stock: "",
                points: _pointsPrice(row?.itemPricing, 'oneTime', row?.isEligibleForAutoOrder),
                autoshipType: 'oneTime',
                frequency: 'oneTime',
                description1: row?.otherFields?.longField1,
                description2: row?.otherFields?.longField2,
                out_of_stock: row?.otherFlags?.flag10,
                category_id: _.includes(pathname, 'main-enrollment') ? _getWebCatId('Enrollment') : selectedCategory,
                product_content: row?.otherFields?.longField1 || '',
                country_Code: row?.itemCode
            })
        }
        return <Component {...props} {...{
            allProductState, setAllProductState, onlyAllProductsData, setOnlyAllProductsData, loading, CATEGORIES, selectedCategory, setSelectedCategory,
            _addToCartFunction, _ProductStructure, _frequancyChange, _checkoutQuantityIncDec,
            _getPorductAccordingSection, setCategory, category,
            section: rankUpgrad === 'ambassador' ? rankUpgrad : section,
            packProducts,
            _quantityIncOrDec: _checkoutQuantityIncDec,
            _onPaginationChange, offset, setOffSet, totalCount: ceil(totalRecords / 10),
            searchText, setSearchText, setSortOrder, sortOrder, setAllOtherProducts, AllOthersProducts

        }} />
    }

    return WithProductHOComponent;
}

export default withProductHOC;